import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import IconButton from '@mui/material/IconButton';
import { createContext, useContext, useState } from 'react';

const ToastContext = createContext();

export const useToast = () => {
  return useContext(ToastContext);
};

export const ToastProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('default'); // 'success', 'error', 'default'

  const showToast = (msg, severity = 'default') => {
    setMessage(msg);
    setSeverity(severity);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getSnackbarContentStyle = () => {
    switch (severity) {
      case 'success':
        return { backgroundColor: 'green' };
      case 'error':
        return { backgroundColor: 'red' };
      default:
        return { backgroundColor: 'grey' };
    }
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <SnackbarContent
          message={message}
          style={getSnackbarContentStyle()}
          action={
            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
              &times;
            </IconButton>
          }
        />
      </Snackbar>
    </ToastContext.Provider>
  );
};
